import DemoDataGenerator from "./DemoDataGenerator";

export default DemoDataGenerator;
